export default {
    BRAND_SELECTED: "brandSelected",
    BRAND_REVIEWED: "brandReviewed",
    REWARD_CREATED: "rewardCreated",
    NEXT: "next",
    BACK: "back",
    CLOSE: "close",
};
